import { render, staticRenderFns } from "./auditAffiliateUser.vue?vue&type=template&id=59d632ec"
import script from "./auditAffiliateUser.vue?vue&type=script&lang=js"
export * from "./auditAffiliateUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports